import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { connect } from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { FORM, INTERNATIONAL, LB_CODE, REQUIRED } from "../../../components/i18n/i18n";
import {PH_CODE, PH_ICON, PH_RELATED_FOOD} from "../../../components/i18n/placeHolders";
import {
    FL_COLOR,
    FL_ICON, FL_RELATED_FOOD,
} from "../../../components/i18n/formLabels";
import AybAttributeLangs from "./_langs";
import TranslatedLangs from "../../../components/genericComponents/TranslatedLangs";

import { save, update } from "../../../redux/actions/ayb/aybAttributeActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";


const AybAttributeForm = props => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { editMode, disableInputs, saveSuccess, domainObject } = props.formProps;
    const translatableLangs= domainObject?.translatedLangs

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            code: domainObject?.code,
            icon: domainObject?.icon,
            relatedImage: domainObject?.relatedImage,
            color: domainObject?.color
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : fbDataBaseId },
            item: {
                ...data,
                uid: domainObject?.uid,
                langs: domainObject?.langs
            }
        }

        if (!editMode)
            return props.save(dataRequest);
        else {
            let id = domainObject.id;
            dataRequest.item.id = domainObject?.id

            return props.update(id, dataRequest)
        }
    };

    const resetForm = () => {
        props.setForm(false, false, false);
        reset();
    }

    const beginEdit = () => {
        props.setForm(true, false, false);
    }

    const returnToList = () => {
        props.setViewMode("LIST");
        props.setItem(null);
        props.setForm();
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                    disabled={disableInputs}
                                    className={(errors.code ? ' is-invalid' : '')}
                                />
                                { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{ FL_ICON }</Label>
                                <Input
                                    type="text"
                                    name="icon"
                                    placeholder={ PH_ICON }
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{ FL_COLOR }</Label>
                                <Input
                                    type="color"
                                    name="color"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{ FL_RELATED_FOOD }</Label>
                                <Input
                                    type="text"
                                    name="relatedImage"
                                    placeholder={ PH_RELATED_FOOD }
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <TranslatedLangs translatableLangs={translatableLangs} />
                        <AybAttributeLangs />
                    </CardBody>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={ resetForm }/>
                                    <ButtonEdit onClick={ beginEdit }/>
                                    <ButtonCancel onClick={ returnToList }/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={ returnToList }/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>

            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,

    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(AybAttributeForm)